import type { ReactNode } from "react"

import { SelectionChip } from "@coval/ui"

export function EditableFilterChip({
  property,
  operator = "is",
  value,
  onEdit,
  onRemove,
  leading,
}: {
  property: string
  /** Word between property and value; `null` reads `<property> <value>`. */
  operator?: string | null
  value: string
  onEdit?: () => void
  onRemove: () => void
  leading?: ReactNode
}) {
  const label = (
    <>
      {/* The property and the operator sit behind the value the user chose, so
          they lighten against the chip's own ink rather than reaching for a
          neutral text token that would fight the accent. */}
      <span className="opacity-70">{property}</span>{" "}
      {operator !== null && (
        <>
          <span className="opacity-70">{operator}</span>{" "}
        </>
      )}
      <span>{value}</span>
    </>
  )
  return (
    <SelectionChip
      leading={leading}
      className="max-w-80"
      label={
        onEdit ? (
          <button
            type="button"
            // The ring is drawn on the chip's own info fill, so it takes the
            // ink chosen to read against that fill rather than the fill's
            // border token, which the dark theme sets to the fill's colour.
            className="rounded text-left focus-visible:outline-none"
            aria-label={`Edit ${property} filter: ${value}`}
            onClick={onEdit}
          >
            {label}
          </button>
        ) : (
          label
        )
      }
      onRemove={onRemove}
      removeLabel={`Remove ${property} filter: ${value}`}
    />
  )
}
